module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-backplates.ff7eefd3.png";